<div class="relative w-full overflow-hidden rounded-[18px] rounded-bl-none bg-white p-5 shadow-sm">
  @if (disabled()) {
    <div class="absolute inset-0 z-10 cursor-not-allowed rounded-[18px] bg-white/60"></div>
  }

  @if (payload().question) {
    <h3 class="mb-3 text-base font-semibold leading-snug text-solid-black-500">
      {{ payload().question }}
    </h3>
  }

  <div class="mt-4 space-y-4">
    @for (group of groups(); track group.title) {
      <div>
        <h4 class="mb-2 text-xs font-semibold uppercase tracking-wide text-solid-black-500/50">
          {{ group.title }}
        </h4>
        <div class="flex flex-wrap gap-2">
          @for (slot of group.slots; track slot.id) {
            <bevvi-option-chip
              [label]="slot.label"
              [selected]="slot.selected ?? false"
              [mode]="OptionChipMode.SINGLE"
              [disabled]="disabled()"
              (click)="selectSlot(slot.id)"
              (keydown.enter)="selectSlot(slot.id)"
              (keydown.space)="selectSlot(slot.id)"
            />
          }
        </div>
      </div>
    }
  </div>

  <div class="mt-4 flex justify-end">
    <bevvi-cta-button
      [label]="payload().submitText || 'Submit'"
      [variant]="CTAButtonVariant.FILLED"
      [disabled]="!selectedLabel() || disabled()"
      (buttonClick)="onSubmit()"
    />
  </div>
</div>
